module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_7042.8f5253af.png";